import React from "react";
import "../App.css";

const Details = ({ goBack, goNext }) => {
  return (
    <div>
      <div className="details-form">
        <form>
          <label htmlFor="firstname">First name</label>
          <input type="text" id="firstname" required />
          <label htmlFor="lastname">Last name</label>
          <input type="text" id="lastname" required />
        </form>
      </div>
      <button onClick={goBack}>Back</button>
      <button onClick={goNext}>Next</button>
    </div>
  );
};

export default Details;
